
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new_product_2024",
      function () {
        return require("private-next-pages/new_product_2024/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new_product_2024"])
      });
    }
  